module.exports = __webpack_public_path__ + "static/media/candidate.d3b61ffe.svg";